<template>
  <div class="login-page">
    <img src="@/assets/img/bg-login.png" class="bg-image" alt="" />
    <!-- <video class="bg-video" autoplay loop muted>
      <source src="@/assets/video/bg-login-2.mp4" type="video/mp4" />
    </video> -->
    <div class="bg-left">
      <template>
        <div class="logo-box">
          <template v-if="isOwn || oemInstitution">
            <img
              class="icon-logo"
              :src="oemInstitution ? oemInstitution.whAppLogo : projectConfig.logo"
              alt=""
            />
            <p class="app-name">
              {{ oemInstitution ? oemInstitution.whAppName : "微火" }}
            </p>
          </template>
        </div>
        <p>商家专属经营平台</p>
        <p>激发新生活，助力好生意</p>
      </template>
      <div class="main shadow-md">
        <div class="main-box">
          <div class="title">
            <template v-if="isOwn || oemInstitution">
              <img
                :src="(oemInstitution && oemInstitution.whAppLogo) || projectConfig.logo"
                class="icon-logo"
                alt=""
              />
              {{
                loginTab == "login"
                  ? (oemInstitution && oemInstitution.whAppName) || "商户后台"
                  : loginTab == "forgetPasswordForm"
                  ? "找回密码"
                  : "注册账号"
              }}
            </template>
          </div>
          <p v-show="loginTab == 'login'" class="wel-text">WELCOME!</p>
          <template v-if="loginTab == 'login'">
            <el-form
              ref="loginformRef"
              :rules="loginFormRule"
              :model="loginForm"
              :hide-required-asterisk="true"
              label-width="0"
              class="login-form"
            >
              <el-form-item
                class="login-form-item"
                label=""
                prop="userName"
                label-width="0"
              >
                <el-input
                  v-model="loginForm.userName"
                  placeholder="请输入账号"
                  @keyup.enter.native="login"
                  class="username-input"
                >
                  <div slot="prefix">
                    <div class="username-input-prefix">
                      <div class="form-icon">
                        <i class="el-icon-user-solid"></i>
                      </div>
                      &nbsp;+86
                      <!-- <el-select v-model="areaCode" placeholder="请选择">
                        <el-option-group
                          v-for="group in areaCodeList"
                          :key="group.code"
                          :label="group.zh"
                        >
                          <el-option
                            v-for="item in group.options"
                            :key="item.en"
                            :label="`+${item.code}`"
                            :value="item.code"
                          >
                            <span style="float: left">{{ item.zh }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px"
                              >+{{ item.code }}</span
                            >
                          </el-option>
                        </el-option-group>
                      </el-select> -->
                    </div>
                  </div>
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="passWord" label-width="0">
                <el-input
                  :type="isShowPassword ? 'text' : 'password'"
                  v-model="loginForm.passWord"
                  placeholder="请输入密码"
                  @keyup.enter.native="login"
                >
                  <div slot="append">
                    <div class="form-icon">
                      <i
                        class="iconfont"
                        :class="isShowPassword ? 'icon002yincang' : 'iconyincang'"
                        @click="isShowPassword = !isShowPassword"
                      ></i>
                    </div>
                  </div>
                  <div slot="prefix">
                    <div class="form-icon">
                      <i class="el-icon-lock"></i>
                    </div>
                  </div>
                </el-input>
              </el-form-item>
              <div class="image-captcha-code">
                <el-form-item
                  class="login-form-item"
                  prop="imageCaptchaCode"
                  label-width="0"
                >
                  <el-input
                    v-model="loginForm.imageCaptchaCode"
                    class="vcode-input"
                    placeholder="请输入图形验证码"
                    @keyup.enter.native="login"
                  >
                    <!-- <template slot="append">
                    </template> -->
                  </el-input>
                </el-form-item>

                <img @click="findImageCaptcha" :src="imageCaptchaUrl" alt />
              </div>
            </el-form>
            <div class="pre-btn">
              <el-link
                type="info"
                :underline="false"
                @click="loginTab = 'forgetPasswordForm'"
                >找回密码</el-link
              >
            </div>
            <el-button
              class="login-btn"
              type="primary"
              :loading="isLoading"
              @click="login"
              >立即登录</el-button
            >
            <div class="next-btn">
              <el-link type="info" :underline="false" @click="loginTab = 'registerForm'"
                >注册账号</el-link
              >
            </div>
          </template>
          <template v-else-if="loginTab == 'forgetPasswordForm'">
            <forgetPasswordForm @changeTab="loginTab = 'login'"></forgetPasswordForm>
          </template>
          <template v-else-if="loginTab == 'registerForm'">
            <registerForm @changeTab="loginTab = 'login'"></registerForm>
          </template>
          <!-- <p class="tagging">@2023 温州专帮信息科技有限公司 版权所有</p> -->
        </div>
        <!-- <p class="tagging">@{{ new Date().getFullYear() }} 温州专帮信息科技有限公司 版权所有</p> -->
      </div>
    </div>
    <div class="bg-right"></div>
  </div>
</template>

<script>
import areaCodeList from "@/assets/js/code.json";
import { findImageCaptcha, pclogin, getOemInfo, findUserFuncInfo } from "@/api";
import md5 from "js-md5";
import { mapState, mapActions } from "vuex";
import forgetPasswordForm from "@/views/forgetPasswordForm.vue";
import registerForm from "@/views/registerForm.vue";
export default {
  data() {
    return {
      loginTab: "login",
      loginForm: {
        userName: "",
        passWord: "",
        imageCaptchaCode: "",
        imageCaptchaToken: "",
      },
      loginFormRule: {
        userName: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        passWord: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        imageCaptchaCode: [
          {
            required: true,
            message: "请输入图形验证码",
            trigger: "blur",
          },
        ],
      },
      areaCodeList: areaCodeList,
      areaCode: 86,
      isShowPassword: false,
      imageCaptchaUrl: "",
      copyRightShow: true,
      isLoading: false,
    };
  },
  components: {
    forgetPasswordForm,
    registerForm,
  },
  computed: {
    ...mapState({
      projectConfig: (state) => state.projectConfig,
      oemInstitution: (state) => state.oemInstitution,
      isOwn: (state) => state.isOwn,
    }),
  },
  created() {
    console.log(1111, location.href);
    if (location.href.indexOf("xcx.douzhiwei.com.cn") != -1) {
      location.href = "https://pay.douzhiwei.com.cn/shopweb/logon_mer.html";
    }
  },
  mounted() {
    localStorage.removeItem("sessionId");
    localStorage.removeItem("userId");
    localStorage.removeItem("userType");
    localStorage.removeItem("shopStoreId");
    this.findImageCaptcha();
    let url = window.location.href;
    if (url.indexOf("wei.gg") >= 0) {
      // 包含
      this.copyRightShow = true;
    } else {
      // 不包含
      this.copyRightShow = false;
    }
  },
  methods: {
    ...mapActions(["updateOemInfo", "updateUserFuncInfo"]),
    getOemInfo() {
      getOemInfo({
        shopStoreId: "",
      }).then((res) => {
        if (res.code == 1) {
          this.updateOemInfo(res.data);
        }
      });
    },
    findUserFuncInfo() {
      findUserFuncInfo({
        userFuncType: 101,
      }).then((res) => {
        if (res.code == 1) {
          this.updateUserFuncInfo(res.data);
        }
      });
    },
    findImageCaptcha() {
      findImageCaptcha().then((res) => {
        if (res.code == 1) {
          this.imageCaptchaUrl = res.data.imageCaptchaUrl;
          this.loginForm.imageCaptchaToken = res.data.imageCaptchaToken;
        }
      });
    },
    login() {
      this.$refs.loginformRef.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.loginForm));
          params.passWord = md5(params.passWord).toUpperCase();
          let deviceCode = "";
          if (localStorage.deviceCode) {
            deviceCode = localStorage.deviceCode;
          } else {
            deviceCode = +new Date();
            localStorage.deviceCode = deviceCode;
          }
          params.deviceCode = deviceCode;
          pclogin(params).then((res) => {
            if (res.code == 1) {
              localStorage.setItem("userId", res.data.id);
              localStorage.setItem("sessionId", res.data.sessionId);
              localStorage.setItem("userType", res.data.userType);
              this.getOemInfo();
              this.findUserFuncInfo();
              this.$router.push({
                path: "/",
              });
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "warning",
                duration: 2000,
              });
              this.findImageCaptcha();
            }
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    linkTo(path) {
      this.$router.push({
        path: path,
      });
    },
  },
};
</script>

<style lang="less">
.login-page {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  .bg-video {
    // min-width: 100vw;
    max-width: none;
    min-height: 100vh;
    min-width: 100vw;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .bg-image {
    height: 100vh;
    width: calc(100vw + 200px);
    position: absolute;
    left: -200px;
    top: 0;
    z-index: 1;
  }
  .bg-left {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    flex: 1;
    z-index: 9;
    // margin-left: 326px;
    width: 1242px;
    min-width: 1242px;
    height: 706px;
    .logo-box {
      display: flex;
      align-items: flex-end;
      height: 82px;
      .icon-logo {
        height: 82px;
        // width: 48px;
      }
      .app-name {
        font-size: 60px;
        line-height: 1;
        font-weight: bold;
        letter-spacing: 4px;
        text-indent: 6px;
        white-space: nowrap;
        color: #fff;
        vertical-align: bottom;
        transform: skewX(-12deg);
      }
      .slogan {
        display: inline-block;
        height: 16px;
        font-size: 12px;
        line-height: 16px;
        transform: skewX(-3deg);
        color: #fff;
        padding: 0 4px;
        background-image: linear-gradient(to right, #26c2da, #89f0b6);
        margin-top: 3px;
        white-space: nowrap;
      }
    }
    & > div,
    & > p {
      position: relative;
      z-index: 1;
    }
    & > p {
      color: #fff;
      &:nth-of-type(1) {
        font-size: 80px;
        line-height: 94px;
        margin-top: 27px;
        font-weight: 700;
      }
      &:nth-of-type(2) {
        font-size: 40px;
        line-height: 44px;
        margin-top: 26px;
      }
    }
    .bg {
      position: absolute;
      top: 20%;
      width: 100%;
      left: 0;
      z-index: 0;
    }
    .bg-logo {
      width: 120px;
      height: 120px;
      position: absolute;
      top: 50%;
      left: 35%;
      z-index: 0;
    }
    .footnote {
      line-height: 2;
      color: #666666;
      font-size: 18px;
    }
    .footer-icon {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 9;
      width: 1242px;
    }
    .main {
      position: absolute;
      top: 52px;
      right: 0;
      // transform: translate(0, -50%);
      width: 384px;
      height: 480px;
      background: #fff;
      border-radius: 6px;
      display: flex;
      z-index: 2;
      background: rgba(240, 243, 250, 0.6);
      .form-icon {
        font-size: 16px;
        position: relative;
        padding-right: 8px;
        width: 30px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:before {
          position: absolute;
          content: "";
          display: block;
          height: 20px;
          right: 0;
          width: 1px;
          background: rgba(170, 178, 192, 1);
        }
      }
      .main-box {
        padding: 30px 30px 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        .title {
          display: flex;
          align-items: center;
          font-size: 26px;
          // font-weight: 600;
          margin-bottom: 10px;
          text-align: left;
          width: 100%;
          color: #000;
          font-weight: bold;
          margin-top: 18px;
          height: 35px;
          .icon-logo {
            // width: 32px;
            height: 32px;
            margin-right: 8px;
          }
        }
        .wel-text {
          margin-bottom: 30px;
          font-size: 13px;
        }
        .tagging {
          font-size: 18px;
          color: #fff;
          margin-top: 280px;
          white-space: nowrap;
        }
        .login-tabs {
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 100%;
          margin-bottom: 36px;
          .card-title {
            font-size: 24px;
            line-height: 36px;
            font-weight: 700;
            color: rgba(51, 51, 51, 1);
            cursor: pointer;
            &.active {
              color: rgba(15, 119, 255, 1);
            }
          }
        }
        .login-form {
          width: 100%;
          .login-form-item {
            border-radius: 5px;
            height: 44px;
            align-items: center;
            // border: 1px solid rgba(240, 243, 250, 1);
            border: 0;
            flex: 1;
            .el-input {
              height: 40px;
              :deep(.el-input__wrapper) {
                box-shadow: none;
              }
            }
          }
        }
        .pre-btn {
          display: flex;
          justify-content: flex-end;
          height: 30px;
          width: 100%;
        }
        .login-btn {
          width: 100%;
          height: 48px;
          // border-radius: 30px;
          margin-top: 10px;
          // background: #2468f2;
        }
        .next-btn {
          display: flex;
          justify-content: center;
          height: 50px;
          width: 100%;
        }
      }
    }
  }
  .bg-right {
    width: 460px;
    height: 100%;
    background-color: #2468f2;
  }
  .footer {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 43px;
    text-align: center;
    color: #bbbbbb;
    font-size: 12px;
    line-height: 22px;
  }
}
</style>

<style lang="less">
.login-page {
  .bg-left {
    .logo-box {
      margin-top: 100px;
    }
  }
  .main {
    .el-form-item__label {
      text-align: center;
    }
    .el-card__body {
      padding: 30px;
    }
    .is-error {
      .el-input-group__prepend,
      .el-input-group__append {
        border-color: red;
      }
    }
    .image-captcha-code {
      display: flex;
      justify-content: space-between;
      .login-form-item {
        margin-bottom: 0;
      }
      img {
        width: 118px;
        height: 40px;
        margin-left: 18px;
        cursor: pointer;
        border-radius: 5px;
      }
    }
    .el-form-item__content {
      & > .el-input {
        &.el-input-group--append {
          input {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
        }
        .username-input-prefix {
          display: flex;
          .el-select {
            width: 70px;
            background: transparent;
            input {
              border-left: 0;
              border-right: 0;
              border-top: 0;
              border-radius: 5px;
              padding: 0 10px;
              border-bottom: 0;
              background: transparent;
            }
          }
        }
        &.vcode-input input {
          height: 40px;
          padding-left: 10px;
        }
        &.username-input {
          & > input {
            padding-left: 80px;
          }
        }
        & > input {
          border-left: 0;
          border-right: 0;
          border-top: 0;
          border-radius: 5px;
          padding: 0;
          border-bottom: 0;
          background: rgba(255, 255, 255, 0.65);
          padding-left: 60px;
          &::placeholder {
            color: rgba(93, 111, 143, 1);
          }
          &:focus {
            border-color: #66b1ff;
          }
          &:hover {
            border-color: #66b1ff;
          }
        }
        .el-input-group__prepend {
          min-width: 70px;
          width: auto;
          background: #fff;
          border-top: 0;
          border-left: 0;
          border-radius: 0;
          box-shadow: none;
        }
        .el-input-group__append {
          // background: transparent;
          border-top: 0;
          border-left: 0;
          border-right: 0;
          // border-radius: 0;
          border-bottom: 0;
          padding: 0;
          padding-right: 10px;
          box-shadow: none;
          background-color: rgba(255, 255, 255, 0.65);
          img {
            cursor: pointer;
          }

          .form-icon {
            &::before {
              background-color: transparent;
            }
          }
        }
      }
    }
    .login-form-item {
      margin-bottom: 23px;
      .el-form-item__error {
        margin-top: 5px;
      }
    }
  }
}
</style>
